import {
    Component,
    Inject,
    OnInit,
    ChangeDetectionStrategy,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { Apollo, QueryRef } from 'apollo-angular';
import { Subscription } from 'rxjs';
import { ProductAiDeliverablesComponent } from '../product-ai-deliverables/product-ai-deliverables.component';
import { ProductHistoryComponent } from './product-history/product-history.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { ProductlocalesComponent } from '../product-locales/product-locales.component';
import { ProductDeliverablesComponent } from '../product-deliverables/product-deliverables.component';

@Component({
    selector: 'app-edit-product',
    templateUrl: './product-detail.component.html',
    styleUrls: ['./product-detail.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        MatTabsModule,
        MatIconModule,
        ProductlocalesComponent,
        ProductAiDeliverablesComponent,
        ProductHistoryComponent,
        ProductDeliverablesComponent,
        MatProgressSpinner,
    ],
})
export class ProductDetailComponent implements OnInit {
    public product: any;
    productQuery?: QueryRef<any>;
    productSubscription?: Subscription;
    productId: any;

    constructor(
        private apollo: Apollo,
        public dialogRef: MatDialogRef<ProductDetailComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {
        this.productId = this.data.productId;
    }

    ngOnInit(): void {
        this.product = this.data.product;
    }
}
